// Single source of truth for "can this pickup's time slot still be edited?".
// Used by BOTH the row-dropdown `change_time_slot` item (list.tsx) and the
// tomorrow-banner inline link (PickupSlotCell.tsx) so the two gates can't
// drift apart.
//
// Slot states where the pickup's route is already locked-in — the backend
// rejects a time-slot edit with SLOT_EDIT_LOCKED (409) for these, so the UI
// hides the edit affordances proactively instead of round-tripping an error.
export const SLOT_EDIT_LOCKED_STATES = ['route_included', 'route_appended'];

export const TERMINAL_PICKUP_STATUSES = ['collected', 'bulk-collected', 'cancelled'];

export const isSlotEditable = (slotState?: string | null, status?: string | null): boolean =>
  !SLOT_EDIT_LOCKED_STATES.includes(slotState || '') &&
  !TERMINAL_PICKUP_STATUSES.includes((status || '').toLowerCase());
